import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import ShadowsDemo from './ShadowsDemo';
import ClientProvider from './client';
export default createDemo(import.meta.url, ShadowsDemo, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/system/shadows/demos/demo/ShadowsDemo.tsx",
    "fileName": "ShadowsDemo.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Grid from '@mui/material/Grid';\nimport Box from '@mui/material/Box';\n\nexport default function ShadowsDemo() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 2,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <Grid container>\n      <Box\n        sx={(theme) => ({\n          boxShadow: 0,\n          width: '8rem',\n          height: '5rem',\n          bgcolor: '#fff',\n          color: 'grey.800',\n          p: 1,\n          m: 1,\n          borderRadius: 2,\n          textAlign: 'center',\n          fontSize: '0.875rem',\n          fontWeight: '700',\n          ...theme.applyStyles('dark', {\n            bgcolor: '#101010',\n            color: 'grey.300',\n          }),\n        })}\n      >\n        boxShadow: 0\n      </Box>\n      <Box\n        sx={(theme) => ({\n          boxShadow: 1,\n          width: '8rem',\n          height: '5rem',\n          bgcolor: '#fff',\n          color: 'grey.800',\n          p: 1,\n          m: 1,\n          borderRadius: 2,\n          textAlign: 'center',\n          fontSize: '0.875rem',\n          fontWeight: '700',\n          ...theme.applyStyles('dark', {\n            bgcolor: '#101010',\n            color: 'grey.300',\n          }),\n        })}\n      >\n        boxShadow: 1\n      </Box>\n      <Box\n        sx={(theme) => ({\n          boxShadow: 2,\n          width: '8rem',\n          height: '5rem',\n          bgcolor: '#fff',\n          color: 'grey.800',\n          p: 1,\n          m: 1,\n          borderRadius: 2,\n          textAlign: 'center',\n          fontSize: '0.875rem',\n          fontWeight: '700',\n          ...theme.applyStyles('dark', {\n            bgcolor: '#101010',\n            color: 'grey.300',\n          }),\n        })}\n      >\n        boxShadow: 2\n      </Box>\n      <Box\n        sx={(theme) => ({\n          boxShadow: 3,\n          width: '8rem',\n          height: '5rem',\n          bgcolor: '#fff',\n          color: 'grey.800',\n          p: 1,\n          m: 1,\n          borderRadius: 2,\n          textAlign: 'center',\n          fontSize: '0.875rem',\n          fontWeight: '700',\n          ...theme.applyStyles('dark', {\n            bgcolor: '#101010',\n            color: 'grey.300',\n          }),\n        })}\n      >\n        boxShadow: 3\n      </Box>\n    </Grid>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 93,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Grid from '@mui/material/Grid';\nimport Box from '@mui/material/Box';\n\nexport default function ShadowsDemo() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 2
        },
        "    <Grid container>\n      <Box\n        sx={(theme) => ({\n          boxShadow: 0,\n          width: '8rem',\n          height: '5rem',\n          bgcolor: '#fff',\n          color: 'grey.800',\n          p: 1,\n          m: 1,\n          borderRadius: 2,\n          textAlign: 'center',\n          fontSize: '0.875rem',\n          fontWeight: '700',\n          ...theme.applyStyles('dark', {\n            bgcolor: '#101010',\n            color: 'grey.300',\n          }),\n        })}\n      >\n        boxShadow: 0\n      </Box>\n      <Box\n        sx={(theme) => ({\n          boxShadow: 1,\n          width: '8rem',\n          height: '5rem',\n          bgcolor: '#fff',\n          color: 'grey.800',\n          p: 1,\n          m: 1,\n          borderRadius: 2,\n          textAlign: 'center',\n          fontSize: '0.875rem',\n          fontWeight: '700',\n          ...theme.applyStyles('dark', {\n            bgcolor: '#101010',\n            color: 'grey.300',\n          }),\n        })}\n      >\n        boxShadow: 1\n      </Box>\n      <Box\n        sx={(theme) => ({\n          boxShadow: 2,\n          width: '8rem',\n          height: '5rem',\n          bgcolor: '#fff',\n          color: 'grey.800',\n          p: 1,\n          m: 1,\n          borderRadius: 2,\n          textAlign: 'center',\n          fontSize: '0.875rem',\n          fontWeight: '700',\n          ...theme.applyStyles('dark', {\n            bgcolor: '#101010',\n            color: 'grey.300',\n          }),\n        })}\n      >\n        boxShadow: 2\n      </Box>\n      <Box\n        sx={(theme) => ({\n          boxShadow: 3,\n          width: '8rem',\n          height: '5rem',\n          bgcolor: '#fff',\n          color: 'grey.800',\n          p: 1,\n          m: 1,\n          borderRadius: 2,\n          textAlign: 'center',\n          fontSize: '0.875rem',\n          fontWeight: '700',\n          ...theme.applyStyles('dark', {\n            bgcolor: '#101010',\n            color: 'grey.300',\n          }),\n        })}\n      >\n        boxShadow: 3\n      </Box>\n    </Grid>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "totalLines": 93,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/material/Grid",
      "@mui/material/Box"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
